export default {
  en: {
    list: {
      title: "Facts",
      buttons: {
        import: "Import Fact List",
        new: "Input new Fact",
        importButton: "Import"
      },
      filters: {
        INPUT: "Input",
        LEARNED: "Collected",
        IMPORTED: "Imported"
      },
      table: {
        origin_type: "Source",
        trait: "Fact Name",
        value: "Value",
        description: "Description",
        created_at: "Inclusion",
        abilities_using_fact: "Used by"
      }
    },
    details: {
      name: "Fact Name",
      usedBy: "Used By <b>{qtd}</b> Abilities",
      noAbilitiesTitle: "There are no abilities using this Fact",
      noAbilitiesDescription:
        "Try check the abilities list to find out wich Fact you need to input.",
      by: "by",
      removeFactOneDescription:
        "Are you sure that you want to remove this Fact from your Fact base ?"
    },
    form: {
      placeholderFactName: "Input the Fact name",
      valueLabel: "Value",
      placeholderFactValue: "Input the Fact value",
      descriptionLabel: "Description",
      placeholderFactDescription:
        "Fill the description field to help identify the Fact",
      placeholderFactsImported: "Search by Fact"
    },
    import: {
      noFactsDetectedTitle: "No Facts detected",
      quantity:
        "No valid Fact found in the uploaded document | <b>{qtd}</b> Fact was found in the uploaded document | <b>{qtd}</b> Facts were found in the uploaded document"
    },
    modal: {
      remove: {
        title: "Remove Fact? | Remove Facts?",
        text: "Are you sure that you want to remove the selected Fact from your database? | Are you sure that you want to remove the selected Facts from your database?"
      }
    }
  },
  pt: {
    list: {
      title: "Facts",
      buttons: {
        import: "Importar lista de Facts",
        new: "Inserir novo Fact",
        importButton: "Importar"
      },
      filters: {
        INPUT: "Inserido",
        LEARNED: "Coletado",
        IMPORTED: "Importado"
      },
      table: {
        origin_type: "Fonte",
        trait: "Nome do Fact",
        value: "Valor",
        description: "Descrição",
        created_at: "Inclusão",
        abilities_using_fact: "Usado por"
      }
    },
    details: {
      name: "Nome do Fact",
      usedBy: "Usado por <b>{qtd}</b> Habilidades",
      noAbilitiesTitle: "Não há Habilidades que usem esse Fact",
      noAbilitiesDescription:
        "Tente verificar a lista de Habilidades para descobrir qual Fact você precisa inserir.",
      by: "por",
      removeFactOneDescription:
        "Tem certeza de que deseja remover esse Fact de sua base de Facts?",
      modal: {
        title: "Importação concluída",
        text: "Conseguimos importar <b>{qtd}</b> Facts da lista carregada."
      }
    },
    form: {
      placeholderFactName: "Insira o nome do Fact",
      valueLabel: "Valor",
      placeholderFactValue: "Insira o valor do Fact",
      descriptionLabel: "Descrição",
      placeholderFactDescription:
        "Preencha o campo de descrição para ajudar a identificar o Fact",
      placeholderFactsImported: "Buscar por Fact"
    },
    import: {
      noFactsDetectedTitle: "Nenhum Fact detectado",
      quantity:
        "Nenhum Fact válido encontrado no documento carregado | <b>{qtd}</b> Fact foi encontrado no documento carregado | <b>{qtd}</b> Facts foram encontrados no documento carregado"
    },
    modal: {
      remove: {
        title: "Remover Fact? | Remover Facts?",
        text: "Tem certeza de que deseja remover o Fact selecionado da sua base de dados? | Tem certeza de que deseja remover os Facts selecionados da sua base de dados?"
      }
    }
  },
  es: {
    list: {
      title: "Facts",
      buttons: {
        import: "Importar Lista de Fact",
        new: "Insertar Nuevo Fact",
        importButton: "Importar"
      },
      filters: {
        INPUT: "Insertado",
        LEARNED: "Recogidos",
        IMPORTED: "Importado"
      },
      table: {
        origin_type: "Fuente",
        trait: "Nombre del Fact",
        value: "Valor",
        description: "Descripción",
        created_at: "Inclusión",
        abilities_using_fact: "Utilizado por"
      }
    },
    details: {
      name: "Nombre del Fact",
      usedBy: "Utilizado por <b>{qtd}</b> Habilidades",
      noAbilitiesTitle: "No hay Habilidades que utilicen este Fact",
      noAbilitiesDescription:
        "Prueba a comprobar la lista de Habilidades para saber qué Fact necesitas insertar.",
      by: "por",
      removeFactOneDescription:
        "¿Está seguro de que desea eliminar este Fact de su base de datos?"
    },
    form: {
      placeholderFactName: "Introduzca el nombre del Fact",
      valueLabel: "Valor",
      placeholderFactValue: "Introduzca el valor del Fact",
      descriptionLabel: "Descripción",
      placeholderFactDescription:
        "Rellene el campo de descripción para ayudar a identificar el Fact",
      placeholderFactsImported: "Buscar por Fact"
    },
    import: {
      noFactsDetectedTitle: "No se detectaron Facts",
      quantity:
        "No se ha encontrado ningún Fact válido en el documento cargado | Se ha encontrado <b>{qtd}</b> Fact en el documento subido  | Se encontraron <b>{qtd}</b> Facts en el documento subido"
    },
    modal: {
      remove: {
        title: "¿Eliminar Fact? | ¿Eliminar Facts?",
        text: "¿Está seguro de que desea eliminar lo Fact seleccionado de su base de datos? | ¿Está seguro de que desea eliminar los Facts seleccionados de su base de datos?"
      }
    }
  }
}
